import * as InstrumentConnectivityConstants from './InstrumentConnectivityConstants';
import { produce } from "immer";
const assign = Object.assign || require('object.assign');


// The initial application state
const initialState = {};

export default function InstrumentConnectivityReducer(state = initialState, action) {
    switch (action.type) {
        case InstrumentConnectivityConstants.INSTRUMENT_CONN_DEVICE_STATE_ADD: {
            if (state[action.payload]) {
                return state;
            }

            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isInstConnStatusDataFetching: false,
                    isInstConnStatusDataFetched: false,
                    isInstConnStatusDataFailed: false,
                    instConnStatus: {}
                };
            });
            return assign({}, state, newState);
        }
        case InstrumentConnectivityConstants.INSTRUMENT_CONN_DEVICE_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }
        case InstrumentConnectivityConstants.INSTRUMENT_CONN_STATUS_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isInstConnStatusDataFetching: true,
                    isInstConnStatusDataFetched : false,
                    isInstConnStatusDataFailed : false
                }
            });
            return assign({}, state, newState);
        }
        case InstrumentConnectivityConstants.INSTRUMENT_CONN_STATUS_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isInstConnStatusDataFetching: false,
                    isInstConnStatusDataFetched: true,
                    isInstConnStatusDataFailed: false,
                    instConnStatus: action.payload.newState
                }
            });
            return assign({}, state, newState);
        }
        case InstrumentConnectivityConstants.INSTRUMENT_CONN_STATUS_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isInstConnStatusDataFetching: false,
                    isInstConnStatusDataFetched: false,
                    isInstConnStatusDataFailed: true
                }
            });
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}
